import { render, staticRenderFns } from "./UserChatFloating.vue?vue&type=template&id=74233ab6&scoped=true"
import script from "./UserChatFloating.vue?vue&type=script&lang=js"
export * from "./UserChatFloating.vue?vue&type=script&lang=js"
import style0 from "./UserChatFloating.vue?vue&type=style&index=0&id=74233ab6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74233ab6",
  null
  
)

export default component.exports